export const NAVIGATE_TO_SIGNUP = 'NAVIGATE_TO_SIGNUP';

export type UIState = { redirectTo: string };
